'use client';

import { CardDirection, CardSize, TileProps, GlowTile } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';

export const UIMarketingBanner: Component<TileProps> = (props: TileProps) => {
    return (
        <GlowTile
            {...props}
            direction={CardDirection.DesktopRow}
            size={CardSize.M}
            content={{
                description: {
                    text: props.content?.description?.text,
                    className: 'line-clamp-3',
                },
                hasRightIcon: true,
                className: 'desktop:max-w-[16rem]',
            }}
            image={{
                ...props.image,
                classNames: {
                    image: 'aspect-[343/108]',
                },
            }}
        />
    );
};
